module.exports = __webpack_public_path__ + "static/destin-logo-3c9da606872a86f1f24c0aa112e40b48.png";